// var swiper = new Swiper(".about-swiper", {
//     spaceBetween: 30,
//     // hashNavigation: {
//     //     watchState: true,
//     // },
//     pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//     },
//     // autoplay: {
//     //   delay: 2000,
//     // },
//     navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//     },
// });

var aboutSlider = new Swiper('.js-about-swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    // loop: true,
    // loopedSlides: 4
});

// $('.popup-youtube, .popup-vimeo').magnificPopup({
//     disableOn: 700,
//     type: 'iframe',
//     mainClass: 'mfp-fade',
//     removalDelay: 160,
//     preloader: false,
//     fixedContentPos: false
// });

$(".js-silver-pack").click(function() {
    $(".js-silver").addClass("active")
    $(".js-gold").removeClass("active")

})

$(".js-gold -pack").click(function() {
    $(".js-gold").addClass("active")
    $(".js-silver").removeClass("active")
})


$(document).ready(function() {
    function countStart() {

        $('.js-count').each(function() {
            let value = parseInt($(this).attr("data-count"))
            let suffixes = ["", "k", "m", "b", "t"];
            let suffixNum = Math.floor(("" + value).length / 3);
            let shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(2));

            if (shortValue > 1) {
                if (shortValue % 1 != 0) {
                    shortValue = shortValue.toFixed(1);
                    let suffixLetter = suffixes[suffixNum]
                }
            } else {
                shortValue = value;
                suffixNum = 0

            }

            // let convertVale = shortValue + suffixes[suffixNum];

            // console.log(convertVale)s;
            $(this).attr("data-count", shortValue)

            $(this).prop('Counter', 0).animate({
                Counter: parseInt($(this).attr("data-count"))
            }, {
                duration: 4000,
                easing: 'swing',
                step: function(now) {

                    $(this).text(Math.ceil(now) + suffixes[suffixNum] + "+");
                }
            });

        })



    }

    var triggerTop = $(".neet").offset().top;

    $(window).scroll(function() {

        var curentScroll = $(window).scrollTop();
        var isViewpoint = curentScroll + 200 > triggerTop
        if (isViewpoint) {

            $(window).off('scroll');
            countStart()

        }
    });

})